// VFX: Floating Alert Badge
// Slug: ui_floating-badge_alert_600ms
// Category: notification-toasts
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

type BadgeType = "success" | "warning" | "info";
type Props = { message?: string; count?: number; type?: BadgeType };

const COLORS: Record<BadgeType, string> = { success: "#34d399", warning: "#f59e0b", info: "#60a5fa" };
const ICONS: Record<BadgeType, string> = { success: "🎉", warning: "!", info: "i" };

export default function UiFloatingBadgeAlert600ms({
  message = "Novo seguidor!",
  count = 1,
  type = "success",
}: Props) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const sp = spring({ frame, fps, config: { stiffness: 350, damping: 20, overshootClamping: false } });
  const color = COLORS[type];
  return (
    <AbsoluteFill style={{ justifyContent: "flex-start", alignItems: "flex-end", padding: "120px 40px 0 0" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          background: "rgba(0,0,0,0.85)",
          backdropFilter: "blur(16px)",
          border: `1.5px solid ${color}40`,
          borderRadius: 50,
          padding: "12px 22px",
          transform: `scale(${sp}) translateX(${interpolate(sp, [0, 1], [60, 0])}px)`,
          opacity: sp,
          boxShadow: `0 4px 30px ${color}40`,
        }}
      >
        <span style={{ fontSize: 24 }}>{ICONS[type]}</span>
        <p style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#fff", fontFamily: "system-ui" }}>{message}</p>
        {count > 1 && (
          <span
            style={{
              background: color,
              borderRadius: 100,
              padding: "2px 10px",
              fontSize: 13,
              fontWeight: 800,
              color: "#000",
            }}
          >
            {count}
          </span>
        )}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
